import { lazyRouteComponent } from "@tanstack/react-router";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { faqJsonLd } from "@/lib/seo-jsonld";

export const faqs = [
  { q: "Hur fungerar företagsupplägget?", a: "Vi ger era medarbetare tillgång till Alkoholprovet så de kan träna obegränsat inför kunskapsprovet för serveringstillstånd. Ni får en samlad faktura och kan lägga till eller ta bort användare löpande." },
  { q: "Hur snabbt kan vi vara igång?", a: "Direkt efter att avtal är tecknat. Vi skickar inloggningsuppgifter samma arbetsdag och medarbetarna kan börja öva inom några minuter – ingen installation eller IT-projekt krävs." },
  { q: "Vilka företag passar lösningen för?", a: "Restauranger, hotell, cateringföretag, eventbolag, nattklubbar, konferensanläggningar och restaurangkedjor. Allt från ett enskilt ställe till nationella koncerner med hundratals platser." },
  { q: "Kan vi följa medarbetarnas framsteg?", a: "Ja. På Team- och Enterprise-nivå får ni administrationsvy med statistik per användare, godkändgrad, tidsåtgång och möjlighet att exportera rapporter inför kunskapsprovet." },
  { q: "Hur faktureras tjänsten?", a: "Samlad månads- eller årsfaktura med F-skatt och svenska momsregler. Inga dolda kostnader och inga uppstartsavgifter på Team-nivå." },
  { q: "Får vi ett ramavtal?", a: "Ja. För kedjor och större organisationer tecknar vi ramavtal med personuppgiftsbiträdesavtal (DPA), SLA och kundansvarig kontakt." },
  { q: "Erbjuder ni utbildning på flera språk?", a: "Plattformen är på svenska, vilket speglar det officiella kunskapsprovet. Vi har även stödfunktioner och hjälpresurser för medarbetare med annat modersmål." },
  { q: "Hur hanterar ni personuppgifter och GDPR?", a: "All data lagras inom EU. Vi tecknar PUB-avtal med er och följer GDPR. Endast nödvändiga uppgifter (namn, e-post, framsteg) lagras för att kunna leverera tjänsten." },
];

const ForetagPage = lazyRouteComponent(() => import("./foretag.view"), "ForetagPage");

export const routeOptions = {
  component: ForetagPage,
  head: () => ({
    meta: [
      { title: "Kunskapsprov för företag – Alkoholprovet B2B" },
      { name: "description", content: "Förbered personalen inför kunskapsprovet för serveringstillstånd: obegränsad träning, samlad faktura och adminvy. Begär offert idag." },
      { name: "keywords", content: "kunskapsprov företag, serveringstillstånd företag, alkohollagen utbildning personal, B2B kunskapsprov, restaurang personal serveringstillstånd, kommunens kunskapsprov övning" },
      { property: "og:title", content: "Kunskapsprov för företag – Alkoholprovet B2B" },
      { property: "og:description", content: "Förbered hela personalen inför kunskapsprovet för serveringstillstånd. Obegränsad träning, samlad faktura och adminvy. Begär offert – svar inom 1 arbetsdag." },
      { property: "og:url", content: "https://alkoholprovet.se/foretag" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/foretag" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Företag", url: "https://alkoholprovet.se/foretag" },
      ]),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Alkoholprovet",
          url: "https://alkoholprovet.se",
          logo: "https://alkoholprovet.se/icon-512.png",
          description: "Sveriges ledande övningsplattform för kunskapsprovet till serveringstillstånd.",
          areaServed: "SE",
          sameAs: [],
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "sales",
            email: "info@alkoholprovet.se",
            availableLanguage: ["Swedish"],
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Alkoholprovet för företag",
          description: "Företagslösning för att förbereda personal inför kunskapsprovet för serveringstillstånd. Inkluderar obegränsad övning, samlad faktura, GDPR-trygg hantering och adminvy.",
          provider: {
            "@type": "Organization",
            name: "Alkoholprovet",
            url: "https://alkoholprovet.se",
          },
          areaServed: {
            "@type": "Country",
            name: "Sweden",
          },
          audience: {
            "@type": "Audience",
            audienceType: "Restauranger, hotell, cateringföretag, eventbolag, barer och nattklubbar",
          },
          serviceType: "Utbildning och förberedelse inför kunskapsprov för serveringstillstånd",
          offers: {
            "@type": "Offer",
            priceCurrency: "SEK",
            availability: "https://schema.org/InStock",
            url: "https://alkoholprovet.se/foretag",
            hasMerchantReturnPolicy: {
              "@type": "MerchantReturnPolicy",
              applicableCountry: "SE",
              returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
            },
            shippingDetails: {
              "@type": "OfferShippingDetails",
              shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "SEK" },
              shippingDestination: { "@type": "DefinedRegion", addressCountry: "SE" },
              doesNotShip: true,
            },
          },

        }),
      },
    ],
  }),
};
